var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgEuroCircle = function SvgEuroCircle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M12 3a9 9 0 1 0 0 18 9 9 0 0 0 0-18M1 12C1 5.925 5.925 1 12 1s11 4.925 11 11-4.925 11-11 11S1 18.075 1 12m7.031-.5a4 4 0 0 0 0 1H11a1 1 0 1 1 0 2H8.877c.733.915 1.86 1.5 3.123 1.5a3.98 3.98 0 0 0 2.666-1.018A1 1 0 0 1 16 16.472 6.001 6.001 0 0 1 6.544 14.5H6a1 1 0 1 1 0-2h.02a6 6 0 0 1 0-1H6a1 1 0 1 1 0-2h.544A6 6 0 0 1 16 7.528a1 1 0 1 1-1.334 1.49A3.98 3.98 0 0 0 12 8c-1.263 0-2.39.586-3.123 1.5H11a1 1 0 1 1 0 2z",
    clipRule: "evenodd"
  })));
};
export default SvgEuroCircle;